import React, { useState, useEffect } from "react";

const CartContext = React.createContext();

const CartProvider = ({ children, businessName }) => {
    const cartName = `foodb-${businessName}-cart`;
    const [cart, setCart] = useState(JSON.parse(localStorage.getItem(cartName) || "[]"));

    useEffect(() => {
        localStorage.setItem(cartName, JSON.stringify(cart));
    }, [cart]);

    const addToCart = (item, qty) => {
        setCart((prevCart) => {
            const existingItemIndex = prevCart.findIndex((cartItem) => cartItem.id === item.id);
            if (existingItemIndex !== -1) {
                return prevCart.map((cartItem, index) => {
                    if (index === existingItemIndex) {
                        return { ...cartItem, qty: cartItem.qty + (qty ? qty : 1) };
                    }
                    return cartItem;
                });
            }
            return [...prevCart, { ...item, qty: qty ? qty : 1 }];
        });
    };

    const removeFromCart = (itemId) => {
        setCart((prevCart) => {
            const existingItemIndex = prevCart.findIndex((cartItem) => cartItem.id === itemId);
            if (existingItemIndex !== -1) {
                const existingItem = prevCart[existingItemIndex];
                if (existingItem.qty > 1) {
                    return prevCart.map((cartItem, index) => {
                        if (index === existingItemIndex) {
                            return { ...cartItem, qty: cartItem.qty - 1 };
                        }
                        return cartItem;
                    });
                } else {
                    return prevCart.filter((cartItem) => cartItem.id !== itemId);
                }
            }
            return prevCart;
        });
    };

    const clearCart = () => {
        setCart([]);
    };

    return (
        <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart }}>{children}</CartContext.Provider>
    );
};

const useCart = () => {
    const onAddToCart = (data, qty) => {
        addToCart(data, qty);
    };

    const { cart, addToCart, removeFromCart, clearCart } = React.useContext(CartContext);
    return { cart, onAddToCart, removeFromCart, clearCart };
};

export { CartProvider };
export default useCart;
